import type { FunctionComponent } from 'preact';

import type {
  RepeaterFunctionInvoker,
  TemplateFunction,
  TemplateFunctionInvoker,
  TemplateResult,
} from 'Components/types';
import type { AutocompleteTypes } from 'Models/autocompleteItem.types';
import type { AutocompleteItem } from 'Models/index';

import type { BrowseAllButtonTemplateParams } from './browseAllButton';
import DropdownItem, { type AutocompleteItemHandlers, type Params as DropdownItemType } from './dropdownItem';

export type Params = {
  sectionTitle?: string;
  query?: string;
  items: RepeaterFunctionInvoker<DropdownItemType>;
  vehicleString?: string;
  totalHits?: number;
  browseAllButton?: TemplateFunctionInvoker<BrowseAllButtonTemplateParams>;
};

export type SectionConfig = {
  itemsData: AutocompleteItem[];
  templateName: AutocompleteTypes;
  title: string;
  query?: string;
  vehicleString: string;
  totalHits?: number;
  browseAllButton?: TemplateFunctionInvoker<BrowseAllButtonTemplateParams>;
} & AutocompleteItemHandlers;

export type Props = SectionConfig & {
  template: TemplateFunction<Params>;
};

const Section: FunctionComponent<Props> = ({
  template,
  title,
  query,
  itemsData,
  templateName,
  vehicleString,
  totalHits,
  onClickHandler,
  onMouseOverHandler,
  browseAllButton,
}) => {
  const items: RepeaterFunctionInvoker<DropdownItemType> = itemsData.map((item) => (template) => {
    const props = {
      template,
      item,
      query,
      templateName,
      onClickHandler,
      onMouseOverHandler,
    };

    return (<DropdownItem {...props} key={item.key} />) as TemplateResult;
  });

  return template.call({
    sectionTitle: title,
    query,
    items,
    vehicleString,
    totalHits,
    browseAllButton,
  });
};

export default Section;
